import React from 'react';

import { IconType } from 'components/Icon/constants';
import { Title } from 'components/Toolbar/constants';
import Control from 'components/Toolbar/Controls/Control';
import { useControlWithDropdown } from 'components/Toolbar/hooks';
import TokenPanel from 'components/Toolbar/Token';

interface TokenControlProps {
  panelTitle?: string;
  icon?: IconType;
  className?: string;
  returnFocusToEditor?(): void;
  dataTestId?: string;
  addToken: (token: string) => void;
}

const Token: React.FunctionComponent<TokenControlProps> = (props) => {
  const {
    panelTitle = Title.TOKEN,
    icon = IconType.TOKEN,
    className,
    returnFocusToEditor,
    dataTestId = 'token',
    addToken,
  } = props;
  const { control, isOpen, state, toggleDropdown } = useControlWithDropdown({
    closeDropdownCallback: returnFocusToEditor,
  });

  return (
    <Control
      preventBlur={false}
      ref={control}
      size="sm-md"
      state={state}
      title={panelTitle}
      type={icon}
      className={className}
      onToggle={toggleDropdown}
      dataTestId={`${dataTestId}-control`}
    >
      {isOpen && <TokenPanel
        isOpen={isOpen}
        onToggle={toggleDropdown}
        addToken={(token: string): void => {
          addToken(token);
          toggleDropdown();
        }}
        dataTestId={`${dataTestId}-panel`}
      />}
    </Control>
  );
};

export default Token;
